<template>
  <div>
    <loader :loading="loading"/>

    <page-header :title="`Produtos`">
      <template v-slot:breadcrumbs>
        <li>Produtos</li>
      </template>

      <template v-slot:actions>
        <div>
          <button class="btn btn-success" @click="clearFields" data-bs-toggle="modal" data-bs-target="#modal">Novo Produto</button>
        </div>
      </template>
    </page-header>

    <filters @search="handleSearch(filters, 1)" @clear="clearFilters">
      <form @keyup.enter="handleSearch(filters)">
        <div class="row g-2 p-1">
          <div class="col-12">
            <div>
              <label class="form-label">Nome</label>
              <input type="text" class="form-control form-control-sm" v-model="filters.name">
            </div>
          </div>
        </div>
      </form>
    </filters>

    <div class="card bg-white mt-4">
      <div class="card-body p-4">
        <div class="d-flex align-items-center justify-content-end">
          <span class="small text-secondary" v-if="collection.data.length">
            Mostrando {{ collection.data.length }} de {{ collection.meta.total }} registros
          </span>
        </div>
        <div class="table-responsive mt-3">

          <table class="table table-striped" v-if="collection.data.length">
            <thead>
              <tr>
                <th>Nome</th>
                <th class="text-center">Treinamentos</th>
                <th class="text-center">Status</th>
                <th class="text-end"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="product in collection.data" :key="product.id">
                <td>{{ product.name }}</td>
                <td class="text-center">{{ product.lessons }}</td>
                <td class="text-center">
                  <span v-if="product.status" class="badge bg-success">Ativo</span>
                  <span v-else class="badge bg-secondary">Inativo</span>
                </td>
                <td class="text-end">
                  <div class="btn-group">
                    <button type="button" class="btn btn-primary btn-sm dropdown-toggle"
                            data-bs-popper-config='{"strategy":"fixed"}' data-bs-toggle="dropdown">
                      Ações
                    </button>
                    <ul class="dropdown-menu">
                      <li><a class="dropdown-item" href="#" @click.prevent="edit(product.id)">Editar</a></li>
                      <li><a class="dropdown-item" href="#" @click.prevent="remove(product.id)">Remover</a></li>
                      <li>
                        <hr class="dropdown-divider">
                      </li>
                      <li v-if="product.status"><a class="dropdown-item text-danger" href="#"  @click.prevent="toggleStatus(product)">Inativar</a></li>
                      <li v-else><a class="dropdown-item text-success" href="#" @click.prevent="toggleStatus(product)">Ativar</a></li>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="bg-light p-2 rounded-2 text-center" v-else>Nenhum registro encontrado...</div>

          <div class="d-flex align-items-center justify-content-center mt-4">
            <paginator
                :current-page="collection.meta.current_page"
                :limit-pages="5"
                :pages="collection.meta.last_page"
                @page-changed="handleSearch(filters, $event)"
                v-if="collection.data.length"
            />
          </div>
        </div>
      </div>
    </div>

    <modal id="modal" :custom-classes="['modal-dialog-centered', 'modal-lg']" title="Produto">
      <template #body>
        <div class="row g-2">
          <div class="col-12">
            <label class="form-label">Nome</label>
            <input
                class="form-control"
                v-model="payload.name"
                :class="{ 'is-invalid' : $v.payload.name.$error }"
            />
            <div v-if="$v.payload.name.$error" class="invalid-feedback d-block">Campo Obrigatório!</div>
          </div>
        </div>
      </template>

      <template #footer>
        <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Cancelar</button>
        <button type="button" class="btn btn-primary" @click.prevent="handleSave">Salvar</button>
      </template>
    </modal>

  </div>
</template>
<script>
import {mapActions, mapState} from "vuex";
import PageHeader from "@/components/PageHeader.vue";
import Paginator from "@/components/shared/paginator.vue";
import Loader from "@/components/shared/loader.vue";
import Filters from "@/components/shared/Filters.vue";
import axios from "axios";
import Modal from "@/components/shared/Modal.vue";
import {Modal as bsModal} from "bootstrap";
import {required, requiredIf, url} from "vuelidate/lib/validators";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import lodash from "lodash";

import 'vue2-datepicker/locale/pt-br';
import FormSelect from "../../components/shared/formSelect.vue";

export default {
  props: {},
  components: {
    Modal,
    Filters,
    Loader,
    Paginator,
    PageHeader,
    DatePicker,
    FormSelect
  },
  data() {
    return {
      loading: false,
      selectedOption: null,
      filters: {
        name: ''
      },
      modal: null,
      preview: null,
      payload: {
        id: null,
        name: null
      },
    }
  },
  validations() {
    return {
      payload: {
        name: {required},
      },
    }
  },
  async mounted() {
    this.loading = true;
    await this.handleSearch(this.filters, this.$route.query.page ?? 1);
    this.modal = bsModal.getOrCreateInstance(document.getElementById('modal'));
  },
  methods: {
    ...mapActions('Products', ['getAll']),
    clearFields() {
      this.payload =  {
        name: null
      }
      this.$v.$reset();
    },
    async handleSearch(filters, page = 1) {
      this.loading = true;
      const params = {
        page: page,
        ...filters
      }

      await this.getAll(params).finally(() => {
        this.loading = false;
        this.$scrollTop();
      })

      this.$urlUtils.assignQueryString(this.$route, params);
    },
    clearFilters() {
      this.filters = {
        name: ''
      }

      this.handleSearch(this.filters, 1);
    },
    async edit(id) {
      this.loading = true;
      try {
        const response = await axios.get(`/admin/products/${id}`);
        const { data } = response.data;
        this.payload.id = data.id;
        this.payload.name = data.name;
        this.modal.show();
      } finally {
        this.loading = false;
      }
    },
    async show(id) {
      this.loading = true;

      try {
        const response = await axios.get(`/admin/lessons/${id}/pages`);
        this.selectedPages = response.data.pages;
        this.payload.title = response.data.title;
        this.payload.id = response.data.lesson_id;
        this.modalPages.show();
      } finally {
        this.loading = false;
      }
    },
    async handleSave() {
      this.$v.$touch();
      if(this.$v.$invalid) {
        return false
      }

      this.loading = true;
      const data = this.$serialize(this.payload);

      let url = '/admin/products'
      if(this.payload.id) {
        url = `/admin/products/${this.payload.id}`;
        data.append('_method', 'PUT');
      }console.log
      
      try {
        const response = await axios.post(url, data);
        this.modal.hide();
        this.clearFields();
        this.handleSearch(this.filters, 1);
      } finally {
        this.loading = false;
      }
    },
    async remove(id) {
      await this.$swal.fire({
        text: 'Confirma a exclusão do registro selecionado?',
        showDenyButton: true,
        confirmButtonText: 'Sim',
        denyButtonText: `Não`,
        allowOutsideClick: false
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.loading = true;
          await axios.delete(`/admin/products/${id}`).then(() => {
            this.clearFilters()
          }).catch(() => {
            this.$swal({
              icon: 'error',
              text: 'Ocorreu um erro ao excluir esse produto.'
            })
          }).finally(() => {
            this.loading = false;
          })
        }
      });
    },
    saveLessonPages() {
      let paths = this.selectedPages;
      axios.post(`/admin/lessons/${this.payload.id}/pages`, {paths}).then(response => {
        this.modalPages.hide();
      }).catch(error => {
        this.$swal({
          icon: 'error',
          text: 'Ocorreu um erro ao salvar as páginas do treinamento'
        });
      });
      
    },
    async toggleStatus(product) {
      let text = 'Confirma a inativação do produto?'
      if(product.status === 0) {
        text = 'Confirma a ativação do produto?'
      }
      await this.$swal.fire({
        text: text,
        showDenyButton: true,
        confirmButtonText: 'Sim',
        denyButtonText: `Não`,
        allowOutsideClick: false
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.loading = true;
          await axios.post(`/admin/products/${product.id}/toggle-status`
          ).finally(() => {
            this.handleSearch(this.filters, 1);
            this.loading = false;
          })
        }
      });
    },
  },
  computed: {
    ...mapState('Products', ['collection']),
    categories() {
      if(!this.payload.type) {
        return [];
      }

      return this.root.find(item => item.id === this.payload.type).categories
    },
    filterCategories() {
      if(!this.filters.type) {
        return [];
      }

      return this.root.find(item => item.id === this.filters.type).categories
    },
    pagesRegister(){
      return this.pages.filter(page => {
        return page.id.includes('/add') || page.id.includes('/edit');
      });
    },
    pagesModal(){
      return this.pages.filter(page => {
        return !page.id.includes('/');
      });
    },
    otherPages(){
      return this.pages.filter(page => {
        return !this.pagesRegister.includes(page) && !this.pagesModal.includes(page);
      });
    }
  }
}
</script>
<style lang="scss">
.mx-datepicker {
  width: initial !important;
}

</style>


